import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Solucion } from 'src/app/domain/model/catalogo/solucion';

/**
 * Adaptador HTTP: HttpSolucionRepository
 *
 * Servicio para comunicación HTTP con el catálogo de Soluciones.
 * Endpoint: GET /api/servicios/soluciones
 */
@Injectable({ providedIn: 'root' })
export class HttpSolucionRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/soluciones`;

  /** Lista todas las soluciones activas. */
  async listarActivos(): Promise<Solucion[]> {
    return firstValueFrom(
      this.http.get<Solucion[]>(this.baseUrl)
    );
  }
}
